export default [
    {
        path: '/admin/reports/driver-pickup-statistics',
        name: 'driver-pickup-statistic',
        meta: { requiresAuth: true },
        component: () =>
            import('@/pages/report/delivery/driver-pickup-statistic.vue')
    }
]
